export default __webpack_public_path__ + "static/media/shriyash-jadhav.9423d8bd.png";